import $ from "jquery";

class Countries {
  // 1.- Describe and create/initate our object
  constructor() {
    this.countries_ddl = $("#countries_ddl");
    this.states_ddl = $("#states_ddl");
    this.statesDiv = $("#states_div");
    this.statesDivNoState = $("#states_div_NoStates");
    this.selectMessage = $("#selectMessage");
    this.countriesJSON = require("../../CountriesStates.json");
    this.events();
    this.countriesJsonObj;
    this.fillCountries_ddl();
    this.fillStates_ddl();
  }

  // 2.- events
  events() {
    this.countries_ddl.on("change", this.fillStates_ddl.bind(this));
  }

  // 3.- methods (function, action...)

  fillCountries_ddl() {
    var countriesHtml = "";
    $.each(this.countriesJSON, function (key, value) {
      $.each(value, function (key, value) {
        countriesHtml +=
          "<option value='" + value.iso2 + "'>" + value.name + "</option>";
      });
    });

    this.countries_ddl.html(countriesHtml);

    this.countries_ddl.val("US");
  }

  fillStates_ddl() {
    var cty = this.countries_ddl.val();
    var statesHtml = "";
    var statesLength = 0;

    $.each(this.countriesJSON.data, function (key, value) {
      if (value.iso2 == cty) {
        statesLength = value.states.length;
        if (value.states.length) {
          $.each(value.states, function (key, value) {
            statesHtml +=
              "<option value='" +
              value.state_code +
              "'>" +
              value.name +
              "</option>";
          });
        }
      }
    });
    this.states_ddl.html(statesHtml);

    if (cty == "CA") {
      this.selectMessage.html("Select Province: ");
    } else {
      this.selectMessage.html("Select State: ");
    }

    if (statesLength > 0) {
      this.states_ddl.html(statesHtml);
      this.statesDiv.show();
      this.statesDivNoState.hide();
    } else {
      this.statesDiv.hide();
      this.statesDivNoState.show();
    }
  }
}

export default Countries;
